'use client'

import { useEffect, useState } from 'react'

import { useRouter } from 'next/navigation'

import { Box, useTheme as useMuiTheme } from '@mui/material'

// Import your custom AppBar component
import AppBar from '@/components/common/app_bar'
import Footer from '@/components/landing/footer'
// Components
import HeroSection from '@/components/landing/hero_section'
import InternalNews from '@/components/landing/internal_news'
import RegionalOperations from '@/components/landing/regional_operations'
import SystemModules from '@/components/landing/system_modules'
import TrainingResources from '@/components/landing/training_resources'
import PageBackground from '@/components/layout/page_background'
// Types & Utils
import { AUTH_ROUTES } from '@/lib/routes/auth-routes'
// Import the custom theme hook
import { useTheme } from '@/providers/theme.provider'

export default function InternalLandingPage() {
  const router = useRouter()
  const muiTheme = useMuiTheme()
  const { isDarkMode, toggleTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Navigation handler
  const handleStaffPortalClick = () => {
    router.push(AUTH_ROUTES.STAFF.LOGIN)
  }

  // Prevent hydration issues
  if (!mounted) {
    return null
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: muiTheme.palette.background.default,
        position: 'relative',
      }}
    >
      {/* Background */}
      <PageBackground variant="landing" animate={false} />

      {/* Custom App Bar with proper props */}
      <AppBar
        variant="public"
        showLanguageSelector={true}
        showNotifications={false}
        systemStatus="operational"
        onThemeToggle={toggleTheme}
        isDarkMode={isDarkMode}
      />

      {/* Main Content */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {/* Hero Section */}
        <HeroSection onStaffPortalClick={handleStaffPortalClick} mounted={mounted} />

        {/* System Modules */}
        <SystemModules mounted={mounted} />

        {/* Internal News */}
        <InternalNews mounted={mounted} />

        {/* Training & Resources */}
        <TrainingResources mounted={mounted} />

        {/* Regional Operations */}
        <RegionalOperations mounted={mounted} />

        {/* Footer */}
        <Footer />
      </Box>
    </Box>
  )
}
